import "./uploadFilePage.css";
import { useState } from "react";
import _, { set } from "lodash";
import { ethers } from "ethers";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import * as Papa from 'papaparse';
import { Box, Button, Container, Stack, Typography } from "@mui/material";
import { FileUploader } from "react-drag-drop-files";
import { useWeb3AuthContext } from "../../contexts/web3Auth";
import { useAddMultipleHolders } from "../../hooks/useAddMultipleHolders";
import { useUpdateMultipleHoldersBalance } from "../../hooks/useUpdateMultipleHoldersBalance";
import { setData } from "../status/statusSlice";
import { ImagesLarge } from "../../utils";
import RPC from "../../utils/ethersRPC"
import Top from "../../components/top/Top";
import DialogConfirm from "../../components/dialogConfirm/DialogConfirm";
import DialogStatus from "../../components/dialogStatus/DialogStatus";
import Loading from "../../components/loading/Loading";
import IconFileUploadActive from "../../assets/images/icons/icon-folder.png";
import IconDownload from "../../assets/images/icons/icon-download.png"
import { CSVLink } from "react-csv";
import { exampleCSVdata } from "../../assets/csv/exampleCSVdata";
import DownloadExampleCSV from "../../components/downloadExampleCSV/DownloadExampleCSV";

const fileTypes = ["CSV"];

export const UploadFilePage = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { web3AuthAction } = useWeb3AuthContext();
    const { onAddMultipleHolders, waitAddMultipleHolders } = useAddMultipleHolders();
    const { onUpdateMultipleHolders, waitUpdateMultipleHolders } = useUpdateMultipleHoldersBalance();
    const [open, setOpen] = useState(false);
    const [listAmount, setListAmount] = useState<any>([]);
    const [listHolder, setListHolder] = useState<any>([]);
    const [listCustomerId, setListCustomerId] = useState<any>([]);
    const [openStatus, setOpenStatus] = useState(false);
    const [isError, setIsError] = useState(false);
    const [message, setMessage] = useState("");
    const [txHash, setTxHash] = useState("");
    const handleClose = () => {
        setOpen(false);
        setUploadedFiles([])
    };

    const [uploadedFiles, setUploadedFiles] = useState<any>(null);

    const handleChange = (file: any) => {
        setUploadedFiles(file);
        let mapHolder: any[] = [];
        let mapAmount: any[] = []
        let mapCustomerId: any[] = []
        if (file) {
            Papa.parse(file, {
                header: true,
                skipEmptyLines: true,
                complete: function (results: any) {
                    if (results.data) {
                        try {
                            results.data.map((response: any) => {
                                const zero = Object.keys(response)[0]
                                const first = Object.keys(response)[1]
                                const second = Object.keys(response)[2]
                                console.log("response:", response)
                                console.log(_.get(response, zero))
                                console.log(_.get(response, first))
                                console.log(_.get(response, second))
                                mapCustomerId.push(_.get(response, second))
                                mapHolder.push(_.get(response, zero))
                                mapAmount.push(ethers.parseUnits(_.get(response, first).replace(/,/g, ""), 18))
                                console.log("mapAmount:", mapAmount)
                                setListAmount(mapAmount)
                                setListHolder(mapHolder)
                                setListCustomerId(mapCustomerId)
                                setOpen(true);
                            })
                        } catch (error) {
                            handleClose();
                            setIsError(true);
                            setTxHash("");
                            setMessage("Invalid data");
                            setOpen(false);
                            setOpenStatus(true);
                        }
                    }
                },
            });
        }
        // setOpen(true);
    };

    const signMessage = async () => {
        if (!web3AuthAction?.provider) {
            // alert("provider not initialized yet");
            return;
        }
        const signedMessage = await RPC.signMessage(web3AuthAction.provider);

        return signedMessage
    };

    const addNewHolder = async () => {
        setOpen(false);
        const signedMessage = await signMessage();
        if (signedMessage && listAmount && listHolder && listCustomerId && web3AuthAction.provider) {
            try {
                const ethersProvider = new ethers.BrowserProvider(web3AuthAction.provider);

                // For ethers v5
                const signer = await ethersProvider.getSigner();
                if (signer) {
                 
                    onAddMultipleHolders(signer, listHolder, listAmount, listCustomerId)
                        .then((value) => {
                            const err = _.get(value, "err");
                            const tx = _.get(value, "tx");
                            const hash = _.get(value, "tx.hash");
                            console.log("value:", value)
                            if (tx) {
                                handleClose();
                                setIsError(false);
                                setTxHash(hash);
                                setMessage("Success!");
                                setOpenStatus(true);
                            } else {
                                console.log("err:", err)
                                console.log("hash:", hash)
                                handleClose();
                                setIsError(true);
                                setTxHash("");
                                setMessage(err);
                                setOpen(false);
                                setOpenStatus(true);
                            }
                        }).catch((err) => {
                            handleClose();
                            setIsError(true);
                            setTxHash("");
                            console.log("err:", err)
                            setMessage(err);
                            setOpen(false);
                            setOpenStatus(true);
                        })
                }
            } catch (error) {
                handleClose();
                setIsError(true);
                setTxHash("");
                setMessage("Transaction failed");
                setOpen(false);
                setOpenStatus(true);
            }
        }
    }

    const updateMultipleHolders = async () => {
        const signedMessage = await signMessage();

        if (signedMessage && listAmount && listHolder && listCustomerId && web3AuthAction.provider) {
            try {
                const ethersProvider = new ethers.BrowserProvider(web3AuthAction.provider);

                // For ethers v5
                const signer = await ethersProvider.getSigner();
                if (signer) {

                    onUpdateMultipleHolders(signer, listHolder, listAmount, listCustomerId)
                        .then((value) => {
                            const err = _.get(value, "err");
                            const tx = _.get(value, "tx");
                            const hash = _.get(value, "tx.hash");
                   

                            if (tx) {
                                handleClose();
                                setIsError(false);
                                dispatch(setData({
                                    txHash: hash,
                                    message: "Update",
                                    description: "Your information has been update"
                                }));
                                setTxHash(hash);
                                setMessage("Success!");
                                // navigate("/status?role=controller")
                                setOpenStatus(true);
                            } else {
                                handleClose();
                                setIsError(true);
                                setTxHash("");

                                setMessage(err);
                                setOpen(false);
                                setOpenStatus(true);
                            }
                        }).catch((err) => {
                            handleClose();
                            setIsError(true);
                            setTxHash("");
                            setMessage(err);
                            setOpen(false);
                            setOpenStatus(true);
                        })
                }
            } catch (error) {
                console.log("error:", error)
                handleClose();
                setIsError(true);
                setTxHash("");
                setMessage("Update failed");
                setOpen(false);
                setOpenStatus(true);
            }
        }
    }
    // const csvValue = exampleCSVdata;

    // const csvData = csvValue.map((row: any) => ({
    //     Holder: row.address,
    //     amount: Number(row.balance).toLocaleString('en-US', { minimumFractionDigits: 18, useGrouping: false }),
    //     externalCustomerId: row.externalCustomerId
    // }));

    // const csvReport = {
    //     filename: `example.csv`,
    //     headers: [
    //         { label: "Holder", key: "Holder" },
    //         { label: "Amount", key: "amount" },
    //         { label: "CustomerId", key: "externalCustomerId" }
    //     ],
    //     data: csvData
    // }

    return (
        <Container sx={{ textAlign: "center" }} maxWidth="md">
            <Box display="flex" flexDirection="column">
                {window.location.pathname === "/controller/new-holder/upload-file" ?
                    <Top title="Add new" subTitle="Holder" />
                    :
                    <Top title="Update" subTitle="Balance" />
                }

                {/* <CSVLink style={{ textDecoration: 'none' }} {...csvReport} data={csvData}>
                    <Typography
                        onClick={() => {
                            console.log("download");
                        }}
                        fontWeight={400}
                        color={'var(--gray)'}
                        sx={{
                            zIndex: 100,
                            fontSize: { xs: '12px', sm: '14px' },
                            cursor: 'pointer',
                            transition: 'transform 0.3s ease', // Smooth scaling transition
                            '&:hover': {
                                transform: 'scale(1.2)', // Scale on hover
                            },
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                        }}
                    >
                        (Download example .CSV file here)
                        <Box sx={{ marginLeft: '10px' }}>
                            <img src={IconDownload} alt="Download CSV" width={34} height={28} />
                        </Box>
                    </Typography>
                </CSVLink> */}
                <DownloadExampleCSV />
                <Box mt={10}>

                    <FileUploader
                        classes="guZdik"
                        handleChange={handleChange} name="file" types={fileTypes}>
                        <Stack gap={5} alignItems={'center'}>
                            <ImagesLarge src={IconFileUploadActive} alt="IconFileUploadActive" />
                            <Stack gap={1}>
                                <Typography fontWeight={400} color={'var(--black)'} sx={{ fontSize: { xs: '16px', sm: '20px' } }}>Drag and drop your file here</Typography>
                                <Typography fontWeight={400} color={'var(--gray)'} sx={{ fontSize: { xs: '12px', sm: '14px' } }}>.CSV file/ Max.  MB</Typography>
                                <Typography fontWeight={500} fontSize={16} color={'var(--primary)'}>{_.get(uploadedFiles, "name", "")}</Typography>
                            </Stack>
                            <Button
                                component="label"
                                role={undefined}
                                variant="contained"
                                tabIndex={-1}
                                sx={{
                                    borderRadius: "28px !important",
                                    width: "200px !important",
                                    color: "white !important",
                                    padding: "4px 24px !important",
                                    backgroundColor: "#151514 !important",
                                    fontSize: "16px !important",
                                    fontWeight: "500 !important",
                                    textTransform: 'none',

                                    "&:hover": {
                                        backgroundColor: "#151514",
                                        opacity: 0.9
                                    }
                                }}
                            >
                                Select a file
                            </Button>
                        </Stack>
                    </FileUploader>
                </Box>
                {/* <div {...getRootProps()}>
                    <input {...getInputProps()} />
                    <Stack
                        mt={6}
                        gap={4}
                        sx={{
                            border: '1px solid var(--black)',
                            borderRadius: "42px",
                            alignItems: 'center',
                            height: '440px',
                            justifyContent: 'center'
                        }}
                    >
                        <ImagesLarge src={IconFileUploadActive} alt="IconFileUploadActive" />
                        <Stack gap={1}>
                            <Typography fontWeight={500} color={'var(--black)'} sx={{ fontSize: { xs: '16px', sm: '20px' } }}>Drag and drop your file here</Typography>
                            <Typography fontWeight={400} color={'var(--gray)'} sx={{ fontSize: { xs: '12px', sm: '14px' } }}>.CSV file/ Max.  MB</Typography>
                            {uploadedFiles.map((file: any) => (
                                <Typography component={'li'} fontWeight={500} fontSize={16} color={'var(--primary)'}>{file.name}</Typography>
                            ))}
                        </Stack>
                        <Button
                            component="label"
                            role={undefined}
                            variant="contained"
                            tabIndex={-1}
                            sx={{
                                borderRadius: "28px !important",
                                width: "200px !important",
                                color: "white !important",
                                padding: "4px 24px !important",
                                backgroundColor: "#151514 !important",
                                fontSize: "16px !important",
                                fontWeight: "500 !important",
                                textTransform: 'none',

                                "&:hover": {
                                    backgroundColor: "#151514",
                                    opacity: 0.9
                                }
                            }}
                        >
                            Select a file
                            <VisuallyHiddenInput type="file" />
                        </Button>
                    </Stack>
                </div> */}
                <DialogConfirm
                    open={open}
                    onClose={() => handleClose()}
                    title="Confirm Add"
                    subTitle={window.location.pathname === "/controller/new-holder/upload-file"
                        ? "New Holder ?"
                        : "Update Balance ?"}
                    description={window.location.pathname === "/controller/new-holder/upload-file"
                        ? "Click confirm to complete add the new holder"
                        : "Click confirm to complete update the balance"}
                    confirm={() => window.location.pathname === "/controller/new-holder/upload-file"
                        ? addNewHolder()
                        : updateMultipleHolders()}
                />
                <DialogStatus
                    open={openStatus}
                    onClose={() =>{ setOpenStatus(false) ; navigate("/controller")}}
                    msgErr={isError}
                    // confirm={() => handleBurnTotalSupply()}
                    title="Confirm"
                    subTitle={isError ? "Error" : message}
                    description={isError ? message + "Please check your holder list is correct" : txHash}
                    updateAndCreate={true}
                />
                {waitAddMultipleHolders &&
                    <Loading loading={waitAddMultipleHolders} />}
                {waitUpdateMultipleHolders &&
                    <Loading loading={waitUpdateMultipleHolders} />}
            </Box>
        </Container>
    );
};

export default UploadFilePage;
